import React, { useRef, useState, useEffect } from 'react';
import { Helmet } from "react-helmet";
import { useParams } from "react-router";
import { YMaps, Map, Placemark } from 'react-yandex-maps';
import { useLocation, NavLink as Link } from 'react-router-dom';
import { animateScroll as scroll } from 'react-scroll';
import moment from 'moment';
import { Tabs, Image, Input, Upload, Skeleton } from 'antd';
import { useSelector, useDispatch } from 'react-redux';
import { UPLOADS, SETTINGS_APP, IMAGES } from '../../params';
import { getAdvertisementId } from '../../API/advertisement';
import { Error404_Component } from "../errors/404";
import { setAdvertisement_id } from "../../redux/advertisement/reducer";
import { MdOutlineNoPhotography } from "react-icons/md";

import edjsParser from 'editorjs-parser';
const parser = new edjsParser();
import parse from 'html-react-parser';

const { TextArea } = Input;
const { Dragger } = Upload;

export const Advertisement = props => {
    
    const dispatch = useDispatch();
    const location = useLocation();
    const app_global = useSelector(state => state.app_global);
    const profile = useSelector(state => state.profile);
    const advertisement = useSelector(state => state.advertisement);

    const [activeTab, setActiveTab] = useState("1");
    
    const params = useParams();

    const isInitialMount = useRef(true);

    useEffect(() => {
        if (isInitialMount.current) {
            isInitialMount.current = false;

        }
    }, []);

    useEffect(async () => {
        await component_start();
    }, [location]);

    useEffect(async () => {
        component_start()
    }, [profile.token]);

    async function component_start() {
        
        dispatch(setAdvertisement_id({}));

        await getAdvertisementId({
            id: params.jobID
        },dispatch,profile)
        .then(async json => {
            console.log ( `%c [API]: [getAdvertisementId]`, `color: #A366FF`, json );

            if (json?.code) {
                if (json?.result) {
                    //Done
                }
            }
        });
    }

    const tabChange = (key) => {
        setActiveTab(key);
        console.log(key);
    };

    function decnum (a,b) { let cases=[2,0,1,1,1,2];return b[(a%100>4 && a%100<20)?2:cases[(a%10<5)?a%10:5]]; }

    /* Вывод номера */
    function customPhoneMask(phone = "") {
        var end = "";
        if (phone !== null) {
            var length = phone.length;
        
            switch(SETTINGS_APP.project_format) {
                case 'UZ':
                    if(length > 0) { if (phone[0] === '9') { end += '+'; } end += phone[0]; }
                    if(length > 1) { end += phone[1]; }
                    if(length > 2) { end += phone[2]; }
                    if(length > 3) { end += " "+phone[3]; }
                    if(length > 4) { end += phone[4]; }
                    if(length > 5) { end += " "+phone[5]; }
                    if(length > 6) { end += phone[6]; }
                    if(length > 7) { end += phone[7]; }
                    if(length > 8) { end += " "+phone[8]; }
                    if(length > 9) { end += phone[9]; }
                    if(length > 10) { end += " "+phone[10]; }
                    if(length > 11) { end += phone[11]; }
                    break;
                default:
                    if(length > 0) { if (phone[0] === '7') { end += '+'; } end += phone[0]; }
                    if(length > 1) { end += "("+phone[1]; }
                    if(length > 2) { end += phone[2]; }
                    if(length > 3) { end += phone[3]+")"; }
                    if(length > 4) { end += phone[4]; }
                    if(length > 5) { end += phone[5]; }
                    if(length > 6) { end += phone[6]; }
                    if(length > 7) { end += "-"+phone[7]; }
                    if(length > 8) { end += phone[8]; }
                    if(length > 9) { end += "-"+phone[9]; }
                    if(length > 10) { end += phone[10]; }
            }
        } else {
            end = "номер не заполнен";
        }

        return end;
    }

    return (
        <>
            {
                app_global.loading ?
                <section className='container shadow default_padding marginTop'>
                    <div className='content'>
                        <Skeleton active />
                    </div>
                </section>
            :
                Object.keys(advertisement.advertisement_id).length > 0 ?
                advertisement.advertisement_id.error_code === 404 ?
                        <Error404_Component />
                    :
                        <>
                            <Helmet>
                                <title>{ advertisement.advertisement_id.seo_title } | Вакансии - Медицинский портал Нижегородской области: информация о врачах и учреждениях здравоохранения</title>
                                <meta property='og:title' content={`${ advertisement.advertisement_id.seo_title } | Вакансии - Медицинский портал Нижегородской области: информация о врачах и учреждениях здравоохранения`} />
                                <meta name="description" content={`${ advertisement.advertisement_id.seo_description !== null ? advertisement.advertisement_id.seo_description : '' }`} />
                                <meta name="og:description" content={`${ advertisement.advertisement_id.seo_description !== null ? advertisement.advertisement_id.seo_description : '' }`} />
                                <meta name="keywords" content={`${ advertisement.advertisement_id.seo_keywords !== null ? advertisement.advertisement_id.seo_keywords : '' }`} />
                            </Helmet>
                            <div className='main --advertisement'>
                                <>
                                    <section className='content banner --org' data-type='custom' style={{'--custom-bg-pc':`url(${IMAGES}/banners/advertisement_header_${advertisement.advertisement_id.type}_pc.jpeg)`, '--custom-bg-mob':`url(${IMAGES}/banners/advertisement_header_${advertisement.advertisement_id.type}_mob.jpeg)`}} >
                                        <div className='header_container'>
                                            <img src={`${IMAGES}/banners/advertisement_header_${advertisement.advertisement_id.type}.png`} />
                                            <p className='orgname_full'>{advertisement.advertisement_id.title}</p>
                                            <div className='mini_divider'></div>
                                            <p className='orgname_last'>
                                                {advertisement.advertisement_id.type === 'search_organization' ? 'Объявление доктора':null}
                                                {advertisement.advertisement_id.type === 'search_doctor' ? 'Объявление организации':null}
                                            </p>
                                        </div>
                                    </section>
                                </>
                                <section className='container xs --org first shadow default_padding'>
                                    <div className='content'>
                                        <div className='custom_tabs'>
                                            <div className='tabs_header'>
                                                <h1>
                                                    {advertisement.advertisement_id.type === 'search_doctor' ? advertisement.advertisement_id.data?.orgname:null}
                                                    {advertisement.advertisement_id.type === 'search_organization' ? advertisement.advertisement_id.data?.name:null}
                                                </h1>
                                            </div>
                                            <Tabs
                                                activeKey={activeTab}
                                                defaultActiveKey="1"
                                                onChange={tabChange}
                                                className="org_tabs"
                                                items={[
                                                    {
                                                        label: `Информация`,
                                                        key: '1',
                                                        children:
                                                        <div className='tab_item tab_1'>
                                                            <>
                                                                <div className={`text_content ${advertisement.advertisement_id.type}`}>
                                                                    {advertisement.advertisement_id.type === 'search_doctor' ?
                                                                        advertisement.advertisement_id.data?.logo !== null ?
                                                                            <img className='specialist_photo' src={`${UPLOADS}/${advertisement.advertisement_id.data?.logo}`} />
                                                                        :
                                                                            <MdOutlineNoPhotography />
                                                                    :
                                                                        null
                                                                    }
                                                                    {advertisement.advertisement_id.type === 'search_organization' ?
                                                                        advertisement.advertisement_id.data?.photo !== null ?
                                                                            <img className='specialist_photo' src={`${UPLOADS}/${advertisement.advertisement_id.data?.photo}`} />
                                                                        :
                                                                            <MdOutlineNoPhotography />
                                                                    :
                                                                        null
                                                                    }
                                                                </div>
                                                                <div className='contact border'>
                                                                    <div className='left'>
                                                                        <div className='phones'>
                                                                            <h3>Телефон для связи:</h3>
                                                                            <div className='list'>
                                                                                {advertisement.advertisement_id.phone !== null ?
                                                                                    <a href={`tel:${customPhoneMask(advertisement.advertisement_id.phone)}`}>{customPhoneMask(advertisement.advertisement_id.phone)}</a>
                                                                                :
                                                                                    <a>не указан</a>
                                                                                }
                                                                            </div>
                                                                            <h3>Email для связи:</h3>
                                                                            <div className='list'>
                                                                                {advertisement.advertisement_id.email !== null ?  
                                                                                    <a href={`mailto:${advertisement.advertisement_id.email}`}>{advertisement.advertisement_id.email}</a>
                                                                                :
                                                                                    <a>не указан</a>
                                                                                }
                                                                            </div>
                                                                        </div>
                                                                        <div className='worktime' >
                                                                            <h3>Специализации:</h3>
                                                                            <span className='list'>
                                                                                {advertisement.advertisement_id.specializations.map((specialization) => { 
                                                                                    return specialization.label
                                                                                }).join(', ')}
                                                                            </span>
                                                                            <div className='list'>
                                                                                <span><b>Опубликовано: </b> {moment.unix(advertisement.advertisement_id.date_up).fromNow()}</span>
                                                                            </div>
                                                                        </div>
                                                                        {advertisement.advertisement_id.connect_id !== null ? 
                                                                            <>
                                                                                {advertisement.advertisement_id.type === 'search_doctor' ?
                                                                                    <Link className="button" exact={ true } onClick={() => scroll.scrollToTop()} to={`/org/${advertisement.advertisement_id.connect_id}`}>Перейти к клинике</Link>
                                                                                :
                                                                                    null
                                                                                }
                                                                                    {advertisement.advertisement_id.type === 'search_organization' ?
                                                                                    <Link className="button" exact={ true } onClick={() => scroll.scrollToTop()} to={`/specialist/${advertisement.advertisement_id.connect_id}`}>Перейти к карточке</Link>
                                                                                :
                                                                                    null
                                                                                }
                                                                            </>
                                                                        :
                                                                            null
                                                                        }
                                                                    </div>
                                                                    <div className='right'>
                                                                        <div className='address'>
                                                                            <div className='list'>
                                                                                {advertisement.advertisement_id.address !== null ? 
                                                                                    advertisement.advertisement_id.address ?
                                                                                        <a href={`https://yandex.ru/maps/?text=${advertisement.advertisement_id.address}`} target="_blank"><b>Адрес:</b> {advertisement.advertisement_id.address}</a>
                                                                                    :
                                                                                        <a><b>Адрес:</b> не указан</a>
                                                                                :
                                                                                    advertisement.advertisement_id.data?.address ?
                                                                                        <a href={`https://yandex.ru/maps/?text=${advertisement.advertisement_id.data?.address}`} target="_blank"><b>Адрес:</b> {advertisement.advertisement_id.data?.address}</a>
                                                                                    :
                                                                                        <a><b>Адрес:</b> не указан</a>
                                                                                }
                                                                            </div>
                                                                        </div>
                                                                        {advertisement.advertisement_id.address !== null ? 
                                                                            <div className='map' style={{display:(advertisement.advertisement_id.latitude === "0" && advertisement.advertisement_id.longitude === "0") ? "none" : null }}>
                                                                                <YMaps>
                                                                                    <Map defaultState={{ center: [advertisement.advertisement_id.latitude, advertisement.advertisement_id.longitude], zoom: 15 }} height="100%" width="100%" >
                                                                                        <Placemark geometry={[advertisement.advertisement_id.latitude, advertisement.advertisement_id.longitude]} />
                                                                                    </Map>
                                                                                </YMaps>
                                                                            </div>
                                                                        :
                                                                            <div className='map' style={{display:(advertisement.advertisement_id.data?.latitude === "0" && advertisement.advertisement_id.data?.longitude === "0") ? "none" : null }}>
                                                                                <YMaps>
                                                                                    <Map defaultState={{ center: [advertisement.advertisement_id.data?.latitude, advertisement.advertisement_id.data?.longitude], zoom: 15 }} height="100%" width="100%" >
                                                                                        <Placemark geometry={[advertisement.advertisement_id.data?.latitude,advertisement.advertisement_id.data?.longitude]} />
                                                                                    </Map>
                                                                                </YMaps>
                                                                            </div>
                                                                        }
                                                                    </div>
                                                                </div>
                                                            </>
                                                        </div>
                                                    },
                                                ]}
                                            />
                                        </div>
                                        <section className='group education_experience'>
                                            <div className='content'>
                                                <div className='list' style={{width:'100%'}}>
                                                        <div className='header'>
                                                            <h2>О вакансии</h2>
                                                        </div>
                                                        {advertisement.advertisement_id.content !== '{}' ?
                                                            Object.keys(JSON.parse(advertisement.advertisement_id.content)).length > 0 ?
                                                                JSON.parse(advertisement.advertisement_id.content)?.blocks.length > 0 ?
                                                                    <div className='text_content'>
                                                                        {parse(parser.parse(JSON.parse(advertisement.advertisement_id.content)))}
                                                                    </div>
                                                                :
                                                                    <div className='text_content'>
                                                                        <p>Информация не указана</p>
                                                                    </div>
                                                            :
                                                                <div className='text_content'>
                                                                    <p>Информация не указана</p>
                                                                </div>
                                                        :
                                                            <div className='text_content'>
                                                                <p>Информация не указана</p>
                                                            </div>
                                                        }
                                                    </div>
                                            </div>
                                        </section>
                                    </div>
                                </section>
                            </div>
                        </>
                :
                    <section className='container shadow default_padding marginTop'>
                        <div className='content'>
                            <Skeleton active />
                        </div>
                    </section>
            }
        </>
    );
};